export default __webpack_public_path__ + "static/media/D02_s.d7655d33.png";